import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./Assets/css/vendor.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "swiper/css";
import "swiper/css/navigation";
import "./Assets/css/style.css";
import "./Assets/css/style2.css";
import "./Assets/css/media.css";
import "./Assets/css/responsive.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./Assets/css/cart.css";
import React, { useEffect } from "react";
import sha256 from "crypto-js/sha256";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setUserData } from "./Redux/ActionCreater";
import PrivateRoute from "./Partial/PrivateRoute";
import BottomInfo from "./Component/Common/BottomInfo";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import StripeWrapper from "./Partial/StripeWrapper";
import Agb from "./Component/Agb/Agb";
import Widerrufsrecht from "./Component/Widerrufsrecht/Widerrufsrecht";
import Nutzungsbedingungen from "./Component/Nutzungsbedingungen/Nutzungsbedingungen";
import AppDatenschutzhinweise from "./Component/AppDatenschutzhinweise/AppDatenschutzhinweise";
import AppSupport from "./Component/AppSupport/AppSupport";
import { trackMetaEvent } from "./Partial/metapixel";
import AgbPackage from "./Component/AgbPackage/AgbPackage";
import ThankyouPageEbooks from "./Component/ThankyouPage/ThankyouPage-ebboks";
import Adventskalender from "./Component/Adventskalender/Adventskalender";
import AdventskalenderStretchband from "./Component/AdventskalenderStretchband/AdventskalenderStretchband";
import AppDatenschutzerklaerung from "./Component/AppDatenschutzerklaerung/AppDatenschutzerklaerung";
import AppNutzungsbedingungen from "./Component/AppNutzungsbedingungen/AppNutzungsbedingungen";
// import Dashboard from "./Component/Dashboard/Dashboard";
// import Wishlist from "./Component/Wishlist/Wishlist";
// import Romina from "./Component/Romina/Romina";
// import Image from "./Partial/Image";

let Header = React.lazy(() => import("./Partial/Header"));
let Footer = React.lazy(() => import("./Partial/Footer"));
let Home = React.lazy(() => import("./Component/Homepage/Home"));
let Workout = React.lazy(() => import("./Component/Workoutpage/Workoutpage"));
let NewWorkourPage = React.lazy(() =>
  import("./Component/NewWorkoutPage/NewWorkoutPage")
);
let Training = React.lazy(() => import("./Component/Training/Training"));
let ChallengeFeb = React.lazy(() => import("./Component/ChallengeFeb/ChallengeFeb"));
let SummerChallenge = React.lazy(() => import("./Component/SummerChallenge/SummerChallenge"));
let Wishlist = React.lazy(() => import("./Component/Wishlist/Wishlist"));
let Dashboard = React.lazy(() => import("./Component/Dashboard/Dashboard"));
let Sarah = React.lazy(() => import("./Component/Sarah/Sarah"));
let Shop = React.lazy(() => import("./Component/Shop/Shop"));
let Recipes = React.lazy(() => import("./Component/Recipes/Recipes"));
let WorkoutDetailsPage = React.lazy(() =>
  import("./Component/WorkoutDetailsPage/WorkOutDetailsPage")
);
let RecipeDetails = React.lazy(() =>
  import("./Component/RecipeDetails/RecipeDetails")
);
let ProductDetails = React.lazy(() =>
  import("./Component/ProductDetails/ProductDetails")
);
let Package = React.lazy(() => import("./Component/Package/Package"));
let Checkout = React.lazy(() => import("./Component/Checkout/Checkout"));
let PackageCheckout = React.lazy(() =>
  import("./Component/PackageCheckout/PackageCheckout")
);
let CartPage = React.lazy(() => import("./Component/CartPage/CartPage"));
let ThankyouPage = React.lazy(() =>
  import("./Component/ThankyouPage/ThankyouPage")
);
let ThankyouSubscription = React.lazy(() =>
  import("./Component/ThankyouPage/ThankyouSubscription")
);
let ThankyouSilberSubscription = React.lazy(() =>
  import("./Component/ThankyouPage/silber-thankyou")
);
let ThankyouPlatinSubscription = React.lazy(() =>
  import("./Component/ThankyouPage/platin-thankyou")
);
let Profile = React.lazy(() => import("./Component/Dashboard/Profile"));
let NewProfile = React.lazy(() => import("./Component/Dashboard/NewProfilePage"));
let Address = React.lazy(() => import("./Component/Dashboard/Address"));
let PackageList = React.lazy(() => import("./Component/Dashboard/PackageList"));
let Trainer = React.lazy(() => import("./Component/Trainer/Trainer"));
let Dominic = React.lazy(() => import("./Component/Dominic/Dominic"));
let Romina = React.lazy(() => import("./Component/Romina/Romina"));
let Impressum = React.lazy(() => import("./Component/Impressum/Impressum"));
let Datenschutz = React.lazy(() => import("./Component/Datenschutz/Datenschutz"));
let Versandkosten = React.lazy(() => import("./Component/Versandkosten/Versandkosten"));
let SweatTogether = React.lazy(() => import("./Component/SweatTogether/SweatTogether"));
let SecuritySettings = React.lazy(() =>
  import("./Component/Dashboard/SecuritySettings")
);
let OrderList = React.lazy(() => import("./Component/Dashboard/OrderList"));
let OrderDetailsPage = React.lazy(() =>
  import("./Component/Dashboard/OrderDetailsPage")
);
let Blog = React.lazy(() => import("./Component/Blog/Blog"));
let BlogDetails = React.lazy(() =>
  import("./Component/BlogDetails/BlogDetails")
);
let FreeSubscription = React.lazy(() =>
  import("./Component/FreeSubscription/FreeSubscription")
);
let Faq = React.lazy(() => import("./Component/Faq/Faq_new"));
let Ernaehrungsguide = React.lazy(() => import("./Component/Ernaehrungsguide/Ernaehrungsguide"));
function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.hash;

    switch (path) {
      // 1️⃣ View Content — Packages
      case "/packages#package":
        window.fbq("track", "ViewContent", {
          content_name: "Packages",
          value: 0,
          currency: "EUR",
        });
        break;

      case "/packages":
        window.fbq("track", "ViewContent", {
          content_name: "Packages",
          value: 0,
          currency: "EUR",
        });
        break;

      // // 2️⃣ Add to Cart
      // case "/cart":
      //   window.fbq("track", "AddToCart", {
      //     content_name: "Selected Package",
      //     content_category: "Cart",
      //     value: 0,
      //     currency: "EUR",
      //   });
      //   break;

      // 3️⃣ Initiate Checkout — Platinum
      case "/package-checkout/9":
        window.fbq("track", "InitiateCheckout", {
          value: 215.88,
          currency: 'EUR',
          content_name: "Platinum Package",

        });
        break;

      // 4️⃣ Initiate Checkout — Gold
      case "/package-checkout/2":
        window.fbq("track", "InitiateCheckout", {
          value: 137.94,
          currency: 'EUR',
          content_name: "Gold Package",
        });
        break;

      // 5️⃣ Initiate Checkout — Silver
      case "/package-checkout/8":
        window.fbq("track", "InitiateCheckout", {
          value: 83.97,
          currency: 'EUR',
          content_name: "Silver Package",
        });
        break;

      // 6️⃣ Purchase — Silver
      case "/subscription-thankyou-silber":
        window.fbq("track", "Purchase", {
          value: 24.99,
          currency: 'EUR',
          content_name: "Silver Package",

        });
        break;

      // 7️⃣ Purchase — Gold
      case "/subscription-thankyou":
        window.fbq("track", "Purchase", {
          value: 137.94,
          currency: 'EUR',
          content_name: "Gold Package",
        });
        break;

      // 8️⃣ Purchase — Platinum
      case "/subscription-thankyou-platin":
        window.fbq("track", "Purchase", {
          value: 214.99,
          currency: 'EUR',
          content_name: "Platinum Package",
        });
        break;

      default:
        break;
    }
  }, [location]);
 useEffect(() => {
      // Parse query params on first page load
    const searchParams = new URLSearchParams(location.search);

    const discount = searchParams.get("discount");
    const utm = searchParams.get("utm");
    const shop = searchParams.get("shop");
    if(utm&&atob(utm)=='facebook'){
       localStorage.setItem("discount_code",atob(discount))
       shop&&localStorage.setItem("shop_code",atob(shop))
    }
  }, []);
  return null; // This component doesn't render anything
}


function App() {
  let dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({
      isLoading: state.dataReducer.isLoading,
    }),
    shallowEqual
  );
  useEffect(() => {
    localStorage.getItem("log_in_data") &&
      dispatch(setUserData(JSON.parse(localStorage.getItem("log_in_data"))));
  });

  useEffect(() => {
    if (window.pintrk) {
      localStorage.getItem("log_in_data")
        ? window.pintrk("track", "pagevisit", {
            em: sha256(
              JSON.parse(localStorage.getItem("log_in_data"))
                ?.email?.trim()
                ?.toLowerCase(),
            ).toString(),
          })
        : window.pintrk("track", "pagevisit");
    }
  }, []);


  return (

    <div className="App">
      <BrowserRouter basename="/">
        <MetaPixelTracker />
        <Header />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Home />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/programs"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Workout />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/training"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<div className="loaddiv">
                  <div class="loader-container">
                    <div class="bouncing-dots">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </div>
                  </div>
                </div>}>
                  <Training />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/workouts"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <PrivateRoute>
                  <NewWorkourPage />
                </PrivateRoute>
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/shop"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Shop />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/recipes"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>

                <Recipes />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/workout-details/:slug"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <WorkoutDetailsPage />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/recipe-details/:slug"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <PrivateRoute>
                  <RecipeDetails />
                </PrivateRoute>
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/product-details/:slug"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <ProductDetails />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/packages"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Package />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/checkout"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <PayPalScriptProvider options={{
                  clientId: "Aa94CU9sr4ldHTWezBY3WkYWhlYeucDfHoWUrvGkdKcdf-LdCxUPmtl-_SGoV865ABAvnXNtGMNDkIlA", components: 'buttons',
                  'disable-funding': 'card,credit,venmo',
                  currency: "EUR",
                  intent: "authorize"
                }}><StripeWrapper><Checkout /></StripeWrapper></PayPalScriptProvider>
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/package-checkout/:id"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <PackageCheckout />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/blog"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Blog />
              </React.Suspense>
            }
          />
          {/* <Route exact path='/blog-details/:slug' element={<React.Suspense fallback={<div className="loaddiv">
          <div class="loader-container">
            <div class="bouncing-dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>}><BlogDetails /></React.Suspense>} /> */}
          {/* <Route exact path='/free-subsription' element={<React.Suspense fallback={<div className="loaddiv">
          <div class="loader-container">
            <div class="bouncing-dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>}><FreeSubscription /></React.Suspense>} /> */}
          {/* <Route exact path='/img' element={<React.Suspense fallback={<div className="loaddiv">
          <div class="loader-container">
            <div class="bouncing-dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>}><Image /></React.Suspense>} /> */}
          <Route
            exact
            path="/cart"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <CartPage />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/thankyou"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <ThankyouPage />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/confirmation-page"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <ThankyouPageEbooks />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/subscription-thankyou"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <ThankyouSubscription />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/subscription-thankyou-silber"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <ThankyouSilberSubscription />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/subscription-thankyou-platin"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<div className="loaddiv">
                  <div class="loader-container">
                    <div class="bouncing-dots">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </div>
                  </div>
                </div>}>
                  <ThankyouPlatinSubscription />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/wish-list"
            element={
              // <PrivateRoute>
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Wishlist />
              </React.Suspense>
              // </PrivateRoute>
            }
          />
          <Route
            exact
            path="/adventskalender"
            element={
              // <PrivateRoute>
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Adventskalender />
              </React.Suspense>
              // </PrivateRoute>
            }
          />

 <Route
            exact
            path="/adventskalender-stretchband"
            element={
              // <PrivateRoute>
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <AdventskalenderStretchband />
              </React.Suspense>
              // </PrivateRoute>
            }
          />

          <Route
            exact
            path="/order-details/:id"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<div className="loaddiv">
                  <div class="loader-container">
                    <div class="bouncing-dots">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </div>
                  </div>
                </div>}>
                  <OrderDetailsPage />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/dashboard"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<div className="loaddiv">
                  <div class="loader-container">
                    <div class="bouncing-dots">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </div>
                  </div>
                </div>}>
                  <Dashboard />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/faq"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Faq />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/trainer/laura-barrett"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Trainer />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/challenge/january"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <ChallengeFeb />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/challenge/summer-challenge"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <SummerChallenge />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/trainer/dominic-harrison"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Dominic />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/trainer/romina"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Romina />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/trainer/sarah-harrison"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Sarah />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/agb"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Agb />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/agb-pakete"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <AgbPackage />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/widerrufsrecht"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Widerrufsrecht />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/app-nutzungsbedingungen"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Nutzungsbedingungen />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/app-datenschutzhinweise"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <AppDatenschutzhinweise />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/app-datenschutzerklaerung"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <AppDatenschutzerklaerung />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/app-nutzungsbedingungen"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <AppNutzungsbedingungen />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/app-support"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <AppSupport />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/impressum"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Impressum />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/datenschutz"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Datenschutz />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/static/sweat-together"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <SweatTogether />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/versandkosten"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Versandkosten />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/ernaehrungsguide"
            element={
              <React.Suspense fallback={<div className="loaddiv">
                <div class="loader-container">
                  <div class="bouncing-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>}>
                <Ernaehrungsguide />
              </React.Suspense>
            }
          />
          <Route path="/*" element={<Navigate to="/" />} />
        </Routes>
        {/* <BottomInfo /> */}
        <Footer />
      </BrowserRouter>
      <ToastContainer position="top-center" autoClose={3000}       // disable auto-close for all toasts
        hideProgressBar={true}  // hide progress bar globally
        newestOnTop={false}
        closeOnClick
      />
      {/* {isLoading && <div className='loaddiv' ><div class="loader"></div></div>} */}

      {isLoading && (
        <div className="loaddiv">
          <div class="loader-container">
            <div class="bouncing-dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
